export const ENTITY_IMAGE_PATHS: Record<string, string> = {
  cow1: '/assets/game/entities/cow1.png',
  human1: '/assets/game/entities/human1.png',
  human2: '/assets/game/entities/human2.png',
  human3: '/assets/game/entities/human3.png',
  bat1: '/assets/game/entities/bat1.png',
  murcielago1: '/assets/game/entities/bat1.png',
  cannonbase: '/assets/game/entities/cannonbase.png',
  basedecanones: '/assets/game/entities/cannonbase.png',
  portal1: '/assets/game/entities/portal1.png',
  plasmastore: '/assets/game/entities/plasmastore.png',
  doublelaserstore: '/assets/game/entities/doublelaserstore.png',
  hearthstore: '/assets/game/entities/hearthstore.png',
  house1: '/assets/game/environment/house1.png',
  house2: '/assets/game/environment/house2.png',
  farm1: '/assets/game/environment/farm1.png',
};

export const DECORATION_IMAGE_PATHS: Record<string, string> = {
  tiledbackground: '/assets/game/backgrounds/tiledbackground.png',
  fondodeaire6: '/assets/game/backgrounds/airbackground6.png',
  airbackground6: '/assets/game/backgrounds/airbackground6.png',
  montanadedecoracion: '/assets/game/backgrounds/decorationmountain.png',
  decorationmountain: '/assets/game/backgrounds/decorationmountain.png',
  fondodemontana4: '/assets/game/backgrounds/mountainbackground4.png',
  mountainbackground4: '/assets/game/backgrounds/mountainbackground4.png',
  bgmazorcas: '/assets/game/backgrounds/bgmazorcas.png',
  fondodemosaico: '/assets/game/backgrounds/bgmazorcas.png',
  suelodebaldosas: '/assets/game/environment/tiledfloor.png',
  tiledfloor: '/assets/game/environment/tiledfloor.png',
  tmtreegreen: '/assets/game/environment/tmtreegreen.png',
  tmtreeorange: '/assets/game/environment/tmtreeorange.png',
  tmvalla: '/assets/game/environment/tmvalla.png',
  arbol1: '/assets/game/environment/tree1.png',
  tree1: '/assets/game/environment/tree1.png',
  arbol2: '/assets/game/environment/tree2.png',
  tree2: '/assets/game/environment/tree2.png',
  rock1: '/assets/game/environment/rock1.png',
  house1: '/assets/game/environment/house1.png',
  house2: '/assets/game/environment/house2.png',
  farm1: '/assets/game/environment/farm1.png',
};

export function normalizeAssetKey(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
}

export function resolveEntityImage(key: string): string {
  const normalized = normalizeAssetKey(key);
  return ENTITY_IMAGE_PATHS[normalized] ?? `/assets/game/spritesheets/${normalized}.png`;
}

export function resolveDecorationImage(key: string): string {
  const normalized = normalizeAssetKey(key);
  return DECORATION_IMAGE_PATHS[normalized] ?? `/assets/game/spritesheets/${normalized}.png`;
}

export function getAliasesForEntity(key: string): string[] {
  const normalized = normalizeAssetKey(key);
  const target = resolveEntityImage(normalized);

  const aliases = Object.keys(ENTITY_IMAGE_PATHS).filter((candidate) => {
    return ENTITY_IMAGE_PATHS[candidate] === target;
  });

  if (!aliases.includes(normalized)) {
    aliases.push(normalized);
  }

  return Array.from(new Set(aliases)).sort();
}

export function getAliasesForDecoration(key: string): string[] {
  const normalized = normalizeAssetKey(key);
  const target = resolveDecorationImage(normalized);

  const aliases = Object.keys(DECORATION_IMAGE_PATHS).filter((candidate) => {
    return DECORATION_IMAGE_PATHS[candidate] === target;
  });

  if (!aliases.includes(normalized)) {
    aliases.push(normalized);
  }

  return Array.from(new Set(aliases)).sort();
}
